import { createContext, useContext } from 'react';
import type { Permission } from './permissions';
import type { AuthUser } from './types';

export type LogoutReason = 'expired' | 'user';

export interface AuthContextValue {
    user: AuthUser | null;
    logoutReason: LogoutReason | null;
    login(loginName: string, password: string): Promise<void>;
    logout(): void;
    can(permission: Permission): boolean;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth(): AuthContextValue {
    const value = useContext(AuthContext);
    if (!value) {
        throw new Error('useAuth must be used inside <AuthProvider>');
    }
    return value;
}
